//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

//css
import styled from "styled-components";

// component
import MyCancelDetail from "./components/MyCancelDetail";

export default function MyCancelDetailPage() {
    return <MyCancelDetail />;
}
